import { dateToString, type IBasicLoadNoId } from '@repo/sdk'
import qs from 'qs'

export const editQuoteUrlGenerator = (
  data: {
    id?: number
    load: IBasicLoadNoId
  },
  url = '/quotes/new?',
) => {
  const {
    company,
    drops,
    load_type,
    notes,
    packaging_type,
    pallets,
    requirements,
    temperature,
    user,
    weight,
  } = data.load
  const defaultValues = {
    company_id: company?.id,
    drops: drops.map(drop => ({
      ...drop,
      date: drop.date && dateToString(drop.date),
      id: null,
      place: {
        ...drop.place,
        country: drop.place?.country_code || '',
      },
      time: {
        from: drop.time.from?.slice(0, 5),
        to: drop.time.to?.slice(0, 5),
        type: drop.time.type,
      },
    })),
    id: data.id || undefined,
    load_type_id: load_type.id,
    notes,
    packaging_type_id: packaging_type === null ? 0 : packaging_type.id,
    pallets,
    requirements,
    temperature,
    user_id: user.id,
    weight,
  }

  return url + qs.stringify(defaultValues)
}
